import React, {Component} from 'react';
import {Query} from '@apollo/client/react/components';
import LoadedCategory from './LoadedCategoryContainer';

import {CATEGORY_QUERY} from './categoryQuery';
import {HomeRouteContext} from '../../utils/context';
import withQuery from '../../utils/withQuery';

const CategoryWithLoading = withQuery(LoadedCategory);

class CategoryContainer extends Component {
    static contextType = HomeRouteContext;

    render() {
        const {client, categoryId, preview} = this.props;
        const homeRoute = this.context;
        const variables = {categoryId, preview};

        return (
            <Query client={client} {...{query: CATEGORY_QUERY, variables}}>
                {(response) => {
                    return (
                        <CategoryWithLoading
                            {...{...this.props, response, homeRoute}}
                        />
                    );
                }}
            </Query>
        );
    }
}

export default CategoryContainer;
